module.exports = __webpack_public_path__ + "img/Shaanxi-power.9f56f3ba.png";